import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useFormState, useForm } from 'react-final-form';
import { setError } from '../../../actions';
import { NewSearchPopup } from '../NewSearchPopup';
import { ErrorField } from '../../ui/Input/ErrorField';
import { FORM_VALUES } from '../../../utils/helpers/constants';
import { Selector } from '../../ui/Selector';
import { selectSearchFormCurrentCity } from '../../../store/selectors';
import { NewSearchCitiesProps } from './types';
import { useCityAndLocationsQuery } from '../../useCityAndLocationsQuery';

export const NewSearchCities = ({
  listType = 'search',
  setCitiesLoading,
  citiesPopupIsOpen,
  openCitiesHandler,
  closeCitiesHandler,
  setInitCoordinates,
  showSelector = true
}: NewSearchCitiesProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();
  const isCreate = listType === 'create';
  const [isError, setIsError] = useState(false);
  const currentCity = useSelector(selectSearchFormCurrentCity);

  const { data, error, loading } = useCityAndLocationsQuery(
    values.city_id || currentCity
  );
  const title = `${t('search.city_search.title')}${isCreate ? ' *' : ''}`;

  useEffect(() => {
    if (error) dispatch(setError(true));
  }, [error]);

  useEffect(() => {
    if (data?.city) {
      change('cityHasLocations', !!data?.locations.length);
      if (typeof setInitCoordinates === 'function') {
        setInitCoordinates({
          lat: data?.city?.latitude,
          lng: data?.city?.longitude
        });
      }
    }
  }, [data]);

  const cityText = isCreate ? '' : t('search.city_search.any');
  const cityName = data && data.city != null ? data.city.name : cityText;

  useEffect(() => {
    setCitiesLoading?.(loading);
  }, [loading]);

  return (
    <>
      {showSelector && (
        <Selector
          title={title}
          name="city_id"
          value={cityName}
          loading={loading}
          cypress="city-name"
          stat="new-search-form-city"
          onClick={openCitiesHandler}
        />
      )}
      <NewSearchPopup
        popupTitle={title}
        isCreate={isCreate}
        isOpen={citiesPopupIsOpen}
        data-cy="modal-select-city"
        closePopupHandler={closeCitiesHandler}
        closeHandler={() => closeCitiesHandler(false)}
      />
      {isCreate && (
        <ErrorField
          setError={setIsError}
          margin={isError ? 15 : 0}
          field={FORM_VALUES.cityId}
          cypress="city-id-field-error"
        />
      )}
    </>
  );
};
